import { connectWithStore } from '@common/connectWithStore';
import { fetchData, getInvoices } from '@redux/ducks/invoices';
import { getCurrentAccount } from '@redux/ducks/global';
import { InvoicesPageDispatchProps, InvoicesPageStateProps, InvoicesPageWithLoading } from './InvoicesPage';

const mapStateToProps = (state): InvoicesPageStateProps => {
  const { isFetching, isError, invoices, currentCharge } = getInvoices(state);
  const currentAccount = getCurrentAccount(state);

  return {
    currentAccount,
    invoices,
    currentCharge,
    isError,
    isLoading: isFetching,
  };
};

const mapDispatchToProps: InvoicesPageDispatchProps = {
  fetchData,
};

export const InvoicesPageContainer = connectWithStore(mapStateToProps, mapDispatchToProps)(InvoicesPageWithLoading);
